<template>
  <v-dialog :value="value" persistent max-width="800px">
    <nv-form
      v-if="item != null"
      :errors="formErrors"
      title="New Parameter"
      :loading="loading"
      @cancel="formCancel"
      @nv-submit="formSubmit"
    >
      <v-row>
        <v-col cols="12">
          <v-autocomplete
            ref="name"
            v-model="item.master_parameter_id"
            :rules="rules.masterParameterID"
            :items="masterParameters"
            data-cy="param-name"
            item-text="name"
            item-value="id"
            label="Name"
            hint="The parameter name"
          />
        </v-col>
      </v-row>
    </nv-form>
  </v-dialog>
</template>

<script>
import HTTP from '@/api/dog';
import { FormMixin, enumFetch } from '@nielsen-media/ui-toolkit-vue-api';
import { rules } from './validations';

export default {
  mixins: [FormMixin],
  props: {
    addedParameterIds: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    rules,
    allMasterParameters: [],
  }),
  computed: {
    masterParameters() {
      return this.allMasterParameters.filter(mp => !this.addedParameterIds.includes(mp.id));
    },
  },
  created() {
    this.enumFetch(HTTP, {
      allMasterParameters: '/master_parameters?per_page=300',
    });
  },
  methods: {
    formSave() {
      const selectedParam = this.masterParameters.find(
        mp => mp.id === this.item.master_parameter_id,
      );
      const newParam = {
        master_parameter_id: this.item.master_parameter_id,
        master_parameter: selectedParam,
        value: selectedParam.default_value,
        encoding: selectedParam.encoding,
        status: 'active',
      };
      this.$emit('saved', newParam);
      this.formCancel();
      return Promise.resolve();
    },
    enumFetch,
  },
};
</script>
